import { useState } from 'react'
import goldStar from '../_img/gold_star.png'

const Favorites = ({
  actualIndex,
  PHRASE_DATA,
  setFavorites,
  uncheckFavorites,
}) => {

  function toggleFavorite() {
    PHRASE_DATA[actualIndex].favorite = !PHRASE_DATA[actualIndex].favorite

    //  Get and set a new array of favorites
    const newFavorites = PHRASE_DATA.filter(clip => clip.favorite === true).map(
      clip => clip.phraseId
    )
    console.log({ newFavorites })
    setFavorites(newFavorites)

    //  Do this IF isFav set to false
    if (!PHRASE_DATA[actualIndex].favorite) {
      //  Uncheck favorites IF there are no favorites left
      if (newFavorites.len === 0) {
        uncheckFavorites()
      }
    }
    console.log({ newFavorites })

    //  Fetch - send data to server
    localStorage.setItem(
      'phraseData',
      JSON.stringify({ favorites: newFavorites })
    )
  }

  return (
    <div
      className={`gold-star phrase icon noSelect ${
        !PHRASE_DATA[actualIndex]?.favorite && 'not-this'
      }`}
      onClick={toggleFavorite}
    >
      <img
        src={goldStar}
        alt=""
      />
      <p>favorite</p>
    </div>
  )
}

export default Favorites
